import React from 'react';
import { Box, Grid, TextField, IconButton, Button, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import QuestionEditor from './QuestionEditor';

const SectionEditor = ({
  section,
  sectionIndex,
  onSectionChange,
  onRemoveSection,
  onQuestionChange,
  onAddQuestion,
  onRemoveQuestion,
  validationErrors = {},
  hasInteracted = false
}) => {
  return (
    <Box border={2} borderRadius={8} p={3} mb={4} borderColor="#1976d2">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5}>
          <TextField
            label="Section Title"
            value={section.title}
            onChange={e => onSectionChange(sectionIndex, 'title', e.target.value)}
            variant="outlined"
            fullWidth
            error={!!validationErrors[`section_${sectionIndex}_title`]}
            helperText={validationErrors[`section_${sectionIndex}_title`] ? validationErrors[`section_${sectionIndex}_title`] : ''}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Weightage (%)"
            type="number"
            value={section.weightage}
            onChange={e => onSectionChange(sectionIndex, 'weightage', e.target.value)}
            variant="outlined"
            fullWidth
            error={!!validationErrors[`section_${sectionIndex}_weightage`]}
            helperText={validationErrors[`section_${sectionIndex}_weightage`] ? validationErrors[`section_${sectionIndex}_weightage`] : ''}
          />
        </Grid>
        <Grid item xs={2}>
          <IconButton onClick={() => onRemoveSection(sectionIndex)}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Box mt={2}>
        <Typography variant="subtitle1">Questions</Typography>
        {section.questions.map((question, qIdx) => (
          <QuestionEditor
            key={question.id}
            section={section}
            question={question}
            sectionIndex={sectionIndex}
            questionIndex={qIdx}
            onQuestionChange={(qid, field, value) => onQuestionChange(sectionIndex, qIdx, field, value)}
            onRemoveQuestion={() => {
          
              onRemoveQuestion(sectionIndex, qIdx);
            }}
            validationErrors={validationErrors}
            hasInteracted={hasInteracted}
          />
        ))}
        <Button
          onClick={() => onAddQuestion(sectionIndex)}
          variant="contained"
          color="primary"
          style={{ marginTop: 12, fontWeight: 600, borderRadius: 20 }}
        >
          Add Question
        </Button>
      </Box>
    </Box>
  );
};

export default SectionEditor; 